import { createStyles } from '@mantine/core';

const useStyles = createStyles(theme => ({
  baseHeader: {
    width: '100%',
    background: theme.colors.gray[0],
    padding: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: 0,
    alignItems: 'center',
    gap: theme.spacing.sm,
    overflowX: 'hidden',
    [theme.fn.smallerThan('sm')]: {
      padding: theme.spacing.md,
      paddingBottom: theme.spacing.md,
    },
  },
  title: {
    fontSize: theme.headings.sizes.h1.fontSize,
    lineHeight: theme.headings.sizes.h1.lineHeight,
    whiteSpace: 'normal',
    [theme.fn.smallerThan('md')]: {
      fontSize: theme.headings.sizes.h2.fontSize,
      lineHeight: theme.headings.sizes.h2.lineHeight,
    },
    [theme.fn.smallerThan('sm')]: {
      fontSize: theme.headings.sizes.h3.fontSize,
      lineHeight: theme.headings.sizes.h3.lineHeight,
    },
  },
  total: {
    fontSize: theme.headings.sizes.h1.fontSize,
    lineHeight: theme.headings.sizes.h1.lineHeight,

    whiteSpace: 'nowrap',
    flexShrink: 0,
    [theme.fn.smallerThan('md')]: {
      fontSize: theme.headings.sizes.h2.fontSize,
      lineHeight: theme.headings.sizes.h2.lineHeight,
    },
    [theme.fn.smallerThan('sm')]: {
      fontSize: theme.headings.sizes.h3.fontSize,
      lineHeight: theme.headings.sizes.h3.lineHeight,
    },
  },
  clear: {
    [theme.fn.smallerThan('sm')]: {
      justifySelf: 'end',
    },
  },
  download: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
  searchFilter: {
    width: '100%',
    minWidth: 0,
  },
  dateRangeFilter: {
    width: '100%',
    minWidth: 0,
  },
  athletesFilter: {
    width: '100%',
    minWidth: 0,
  },
  eventTypesFilter: {
    width: '100%',
    minWidth: 0,
  },
}));

export default useStyles;
